// 活動大獎
import Image from 'next/image';

const CampaignMajorPrize = ({ prize, index }) => {
    return (
        <div className="p-[20px] w-[calc((100%-16px)/2)] flex-shrink rounded-[12px] border-1 border-[#fff] border-opacity-[.3] bg-[rgb(128,128,128)] bg-opacity-[.16] backdrop-blur-[15px]">
            {/* 獎品圖 */}
            <div className="img-box w-full aspect-[1/1] rounded-[6px] after:content-none flex-shrink-0">
                <Image width={350} height={350} src={prize?.image} alt={prize?.name} />

                <span
                    className="absolute z-[1] bottom-[7px] left-[6px] rounded-[40px] text-[#f7f7f8] px-[20px] py-[7px] text-btn1 bg-[#000] bg-opacity-[.5]
                backdrop-blur-[5px] border-1 border-[#fff] border-opacity-[.3]"
                >
                    {index === 0 ? '首' : '二'}獎
                </span>
            </div>

            {/* 獎品名稱 */}
            <p className="text-btn3b text-white mt-[15px] mb-[20px]">{prize?.name}</p>

            {/* 獎品數量 */}
            <p className="text-btn1 text-[#c7c7c7]">{prize?.desc}</p>
        </div>
    );
};

export default CampaignMajorPrize;
